import React from 'react';

import PropTypes from 'prop-types';

const PdfViewer = ({ documentUrl }) => {
  return (
    <div style={{ height: '100vh' }}>
      <embed
        src={documentUrl}
        type="application/pdf"
        width="100%"
        height="100%"
      />
    </div>
  );
};

PdfViewer.propTypes = {
  documentUrl: PropTypes.string.isRequired
};

export default PdfViewer;
